// libs
import React, { useState, useRef } from 'react';
import { useForm, Controller } from "react-hook-form";
import { ToastContainer, toast } from 'react-toastify';
import "../../assets/css/form.css";
import "react-datepicker/dist/react-datepicker.css";
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';
// components 
// ...
// config & functions 
import ajaxCall from '../../utils/ajaxcall';
import config from "../../config/index";

function FormModal({loadapidata, apidataparams, setshowformmodalbox, rowid, token, orginfo}) {

    const [InputFields, setInputFields] = useState({
        rowId: "",
        domain: "",
        orgName: "",
        email: "",
        phone: "",
        address: "",
        googleMapsUrl: "",
        stateId: "",
        cityId: "",
        status: "",
        analyticsConfig: "",
        paymentConfig: "",
        paymentGatewayType: "cashfree",
        paymentMode: "both",
        instagramConfig: "",
        hasLoginUser: false,
        loginEmail: ""
    });
    const disabledField = false;
    const [SubmitButton, setSubmitButton] = useState((rowid) ? 'UPDATE RECORD' : 'SAVE RECORD');
    const [Notification, setNotification] = useState({ status: (rowid) ? true : false, message: 'Please wait while we fetch your record' })
    const [DisableSubmitButton, setDisableSubmitButton] = useState(false);
    const [Show, setShow] = useState(false);
    const [CityList, setCityList] = useState([]);
    const [StateList, setStateList] = useState([]);

    const {
        register,
        handleSubmit,
        control,
        formState: { errors },
        reset
    } = useForm();

    const hideModal = () => {
        setShow(false);
        setshowformmodalbox(false)
	}

    const updateChangeEvent = (e, field) => {
		field.onChange(e.target.value);
	}

    const fetchCityList = async () => {
        let apiCall = await ajaxCall.getCall(`${config.api.generic}/city`, {}, token);
        if(apiCall && apiCall.status) {
            setCityList(apiCall.context.message.data);
        }
    }

    const fetchStateList = async () => {
        let apiCall = await ajaxCall.getCall(`${config.api.generic}/state`, {}, token);
        if(apiCall && apiCall.status) {
            setStateList(apiCall.context.message.data);
        }
    }

    const onSubmit = async (data) => {
        setSubmitButton('LOADING...');
        setDisableSubmitButton(true);
        let postData = {
            rowId: rowid,
            domain: data.domain,
            orgName: data.orgName,
            email: data.email || InputFields.email,
            phone: data.phone,
            address: data.address,
            googleMapsUrl: data.googleMapsUrl,
            stateId: data.stateId,
            cityId: data.cityId,
            status: data.status,
            analyticsConfig: JSON.stringify(data.analyticsConfig),
            paymentConfig: JSON.stringify(data.paymentConfig),
            paymentGatewayType: data.paymentGatewayType,
            paymentMode: data.paymentMode,
            instagramConfig: JSON.stringify(data.instagramConfig)
        }

        const nextPassword = (data.loginPassword || '').trim();
        if (!InputFields.rowId) {
            postData.loginPassword = nextPassword;
        } else if (nextPassword) {
            postData.loginPassword = nextPassword;
        }

        let apiCall = "";
        if(InputFields.rowId) {
            apiCall = await ajaxCall.patchCall(`${config.api.generic}/org-accounts`, postData, token);
        } else {
            apiCall = await ajaxCall.postCall(`${config.api.generic}/org-accounts`, postData, token);
        }
        if(apiCall && apiCall.status) {
            setSubmitButton((InputFields.rowId)?'UPDATE RECORD':'SAVE RECORD');
            const successMessage = typeof apiCall.context?.message === 'string'
                ? apiCall.context.message
                : 'Record updated successfully';
            toast.info(successMessage);
            reset();
            setDisableSubmitButton(false);
            setshowformmodalbox(false);
            loadapidata(apidataparams); // refresh list page
        } else {
            setSubmitButton((InputFields.rowId)?'UPDATE RECORD':'SAVE RECORD');
            toast.error(apiCall && apiCall.context.message || 'Something went wrong. Please try again :(');
            setDisableSubmitButton(false);
        }
    }

    // Get data from DB - Used for Edit option
    React.useEffect(() => {
        async function loadComponent() {
            setShow(true);
        }

        async function fetchData() {
            if (rowid) {
                let apiCall = await ajaxCall.getCall(`${config.api.generic}/org-accounts/row`, {
                    rowId: (rowid) ? rowid : 0
                }, token);
                if(apiCall && apiCall.status) {
                    let onLoadData = {
                        rowId: rowid,
                        domain: apiCall.context.message.data[0].domain,
                        orgName: apiCall.context.message.data[0].name,
                        email: apiCall.context.message.data[0].email,
                        phone: apiCall.context.message.data[0].phone,
                        address: apiCall.context.message.data[0].address,
                        googleMapsUrl: apiCall.context.message.data[0].google_maps_url,
                        stateId: apiCall.context.message.data[0].fk_state_id,
                        cityId: apiCall.context.message.data[0].fk_city_id,
                        status: apiCall.context.message.data[0].status,
                        analyticsConfig: apiCall.context.message.data[0].analytics_config,
                        paymentConfig: apiCall.context.message.data[0].payment_config,
                        paymentGatewayType: apiCall.context.message.data[0].payment_gateway_type || 'cashfree',
                        paymentMode: apiCall.context.message.data[0].payment_mode || 'both',
                        instagramConfig: apiCall.context.message.data[0].instagram_config || '',
                        hasLoginUser: Boolean(Number(apiCall.context.message.data[0].has_login_user)),
                        loginEmail: apiCall.context.message.data[0].login_email || apiCall.context.message.data[0].email || ''
                    }
                    setInputFields(onLoadData)
                    setNotification({ status: false })
                } else {
                    setNotification({ status: true, message: 'Sorry something went wrong while fetching record :(' })
                }
            }
        }
        fetchData();
        fetchCityList();
        fetchStateList();
        loadComponent();
    }, []);

    return (
        <>
            <Modal show={Show} size="lg" aria-labelledby="contained-modal-title-vcenter" centered>
                <Modal.Header>
                    <Modal.Title>{rowid?'Update Org Record':'Add Org Record'}</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Container>
                        <Row>
                            <form action="" method="" className="p-sm-1" onSubmit={handleSubmit(onSubmit)}>
                                <Row>
                                    {(Notification.status) ? <Col md="12" className="text-center">{Notification.message}</Col> : <>
                                        <Col md="12">
                                            <div className="text-left mt-3 vt-txt-dark-blue">
                                                <h4><b>Org Info</b></h4>
                                                <hr />
                                            </div>
                                        </Col>
                                        <Col md="6" className="mt-3">
                                            <label className="form-label fs-14rem fw-bold">Status</label>
                                            <Controller
                                                name='status' 
                                                defaultValue={parseInt(InputFields.status)}
                                                rules={{required: true}}
                                                control={control} 
                                                render={({field}) => (
                                                    <select value={field.value || ""} className="form-control custom-select" name="status" onChange={(e) => {updateChangeEvent(e, field)}} disabled={disabledField}>
                                                        <option value="">Choose...</option>
                                                        <option value={0}>Disable</option>
                                                        <option value={1}>Active</option>
                                                    </select>
                                                )}
                                            />	
                                            <small className="form-text text-danger">
                                                {errors.status?.type === "required" && "Please update status"}
                                            </small>
                                        </Col>
                                        <Col md="6" className="mt-3">
                                            <label className="form-label fs-14rem fw-bold">Domain</label>
                                            <input type="text" defaultValue={InputFields.domain} className="form-control" name="domain" {...register("domain", { required: true, minLength: 1, maxLength: 122 })} disabled={disabledField} />
                                            <small className="form-text text-danger">
                                                {errors.domain?.type === "required" && "Domain is mandatory"}
                                            </small>
                                            <small className="form-text text-danger">
                                                {errors.domain?.type === "minLength" && "Enter atleast 1 characters"}
                                            </small>
                                            <small className="form-text text-danger">
                                                {errors.domain?.type === "maxLength" && "Only 122 characters allowed"}
                                            </small>
                                        </Col>
                                        <Col md="6" className="mt-3">
                                            <label className="form-label fs-14rem fw-bold">Org Name</label>
                                            <input type="text" defaultValue={InputFields.orgName} className="form-control" name="orgName" {...register("orgName", { required: true, minLength: 1, maxLength: 122 })} disabled={disabledField} />
                                            <small className="form-text text-danger">
                                                {errors.orgName?.type === "required" && "Org Name is mandatory"}
                                            </small>
                                            <small className="form-text text-danger">
                                                {errors.orgName?.type === "minLength" && "Enter atleast 1 characters"}
                                            </small>
                                            <small className="form-text text-danger">
                                                {errors.orgName?.type === "maxLength" && "Only 122 characters allowed"}
                                            </small>
                                        </Col>
                                        <Col md="6" className="mt-3">
                                            <label className="form-label fs-14rem fw-bold">Email</label>
                                            <input
                                                type="email"
                                                defaultValue={InputFields.email}
                                                className="form-control"
                                                name="email"
                                                {...register("email", {
                                                    required: !rowid,
                                                    minLength: rowid ? undefined : 1,
                                                    maxLength: 122,
                                                })}
                                                readOnly={Boolean(rowid)}
                                                disabled={disabledField}
                                            />
                                            <small className="form-text text-muted">
                                                {rowid ? 'Login email cannot be changed here.' : 'Used as seller login email.'}
                                            </small>
                                            <small className="form-text text-danger">
                                                {errors.email?.type === "required" && "Email is mandatory"}
                                            </small>
                                            <small className="form-text text-danger">
                                                {errors.email?.type === "minLength" && "Enter atleast 1 characters"}
                                            </small>
                                            <small className="form-text text-danger">
                                                {errors.email?.type === "maxLength" && "Only 122 characters allowed"}
                                            </small>
                                        </Col>
                                        <Col md="6" className="mt-3">
                                            <label className="form-label fs-14rem fw-bold">
                                                {rowid
                                                    ? (InputFields.hasLoginUser ? 'Reset Login Password' : 'Set Login Password')
                                                    : 'Login Password'}
                                            </label>
                                            <input
                                                type="password"
                                                className="form-control"
                                                name="loginPassword"
                                                {...register("loginPassword", {
                                                    validate: (value) => {
                                                        const next = (value || '').trim();
                                                        if (!next) {
                                                            return rowid ? true : 'Login password is mandatory';
                                                        }
                                                        if (next.length < 6) {
                                                            return 'Enter at least 6 characters';
                                                        }
                                                        if (next.length > 64) {
                                                            return 'Only 64 characters allowed';
                                                        }
                                                        return true;
                                                    },
                                                })}
                                                autoComplete="new-password"
                                                placeholder={rowid ? 'Leave blank to keep current password' : ''}
                                            />
                                            <small className="form-text text-muted">
                                                {rowid
                                                    ? (InputFields.hasLoginUser
                                                        ? `Optional. Enter a new password for ${InputFields.loginEmail || 'this seller'} to sign in.`
                                                        : `No seller login yet. Enter a password to create access for ${InputFields.loginEmail || InputFields.email || 'this org email'}.`)
                                                    : 'Seller will use this password to sign in.'}
                                            </small>
                                            <small className="form-text text-danger">
                                                {errors.loginPassword?.message}
                                            </small>
                                        </Col>
                                        <Col md="6" className="mt-3">
                                            <label className="form-label fs-14rem fw-bold">Phone</label>
                                            <input type="text" defaultValue={InputFields.phone} className="form-control" name="phone" {...register("phone", { maxLength: 20 })} disabled={disabledField} />
                                            <small className="form-text text-danger">
                                                {errors.phone?.type === "maxLength" && "Only 20 characters allowed"}
                                            </small>
                                        </Col>
                                        <Col md="6" className={`mt-3`}>
                                            <label className="form-label fs-14rem fw-bold">State</label>
                                            <Controller
                                                name='stateId' 
                                                defaultValue={InputFields.stateId}
                                                rules={{required: true}}
                                                control={control} 
                                                render={({field}) => (
                                                    <select value={field.value || ""} className="form-control custom-select" name="stateId" onChange={(e) => {updateChangeEvent(e, field)}} disabled={disabledField}>
                                                        <option value=""> Choose...</option>
                                                        {(Array.isArray(StateList) && StateList.length > 0) ? StateList.map(d => {
                                                            return <option key={Math.random()} value={d.pk_id}>{d.label}</option>
                                                        }):null}
                                                    </select>
                                                )}
                                            />	
                                            <small className="form-text text-danger">
                                                {errors.stateId?.type === "required" && "Please update state"}
                                            </small>
                                        </Col>
                                        <Col md="6" className={`mt-3`}>
                                            <label className="form-label fs-14rem fw-bold">City</label>
                                            <Controller
                                                name='cityId' 
                                                defaultValue={InputFields.cityId}
                                                rules={{required: true}}
                                                control={control} 
                                                render={({field}) => (
                                                    <select value={field.value || ""} className="form-control custom-select" name="cityId" onChange={(e) => {updateChangeEvent(e, field)}} disabled={disabledField}>
                                                        <option value=""> Choose...</option>
                                                        {(Array.isArray(CityList) && CityList.length > 0) ? CityList.map(d => {
                                                            return <option key={Math.random()} value={d.pk_id}>{d.label}</option>
                                                        }):null}
                                                    </select>
                                                )}
                                            />	
                                            <small className="form-text text-danger">
                                                {errors.cityId?.type === "required" && "Please update city"}
                                            </small>
                                        </Col>
                                        <Col md="12" className="mt-3">
                                            <label className="form-label fs-14rem fw-bold">Address</label>
                                            <textarea defaultValue={InputFields.address} className="form-control" name="address" {...register("address", { required: true, minLength: 5, maxLength: 500 })} disabled={disabledField}></textarea>
                                            <small className="form-text text-danger">
                                                {errors.address?.type === "required" && "Address is mandatory"}
                                            </small>
                                            <small className="form-text text-danger">
                                                {errors.address?.type === "minLength" && "Enter atleast 5 characters"}
                                            </small>
                                            <small className="form-text text-danger">
                                                {errors.address?.type === "maxLength" && "Only 500 characters allowed"}
                                            </small>
                                        </Col>
                                        <Col md="12" className="mt-3">
                                            <label className="form-label fs-14rem fw-bold">Google Maps Embed URL</label>
                                            <textarea defaultValue={InputFields.googleMapsUrl} className="form-control" name="googleMapsUrl" {...register("googleMapsUrl", { maxLength: 2000 })} disabled={disabledField}></textarea>
                                            <small className="form-text text-muted">
                                                Go to Google Maps &rarr; Share &rarr; Embed a map &rarr; Copy the src URL from the iframe code
                                            </small>
                                            <small className="form-text text-danger d-block">
                                                {errors.googleMapsUrl?.type === "maxLength" && "Only 2000 characters allowed"}
                                            </small>
                                        </Col>
                                        <Col md="12" className="mt-3">
                                            <label className="form-label fs-14rem fw-bold">Analytics Config</label>
                                            <textarea defaultValue={InputFields.analyticsConfig} className="form-control" name="analyticsConfig" {...register("analyticsConfig", { required: true, minLength: 5})} disabled={disabledField}></textarea>
                                            <div>
                                                <small className="form-text text-muted">
                                                    JSON format: {`{"googleAnalytics":"...","googleTagManager":"..."}`}
                                                </small>
                                            </div>
                                            <div>
                                                <small className="form-text text-danger">
                                                    {errors.analyticsConfig?.type === "required" && "Analytics Config is mandatory"}
                                                </small>
                                                <small className="form-text text-danger">
                                                    {errors.analyticsConfig?.type === "minLength" && "Enter atleast 5 characters"}
                                                </small>
                                            </div>
                                        </Col>
                                        <Col md="6" className="mt-3">
                                            <label className="form-label fs-14rem fw-bold">Payment Gateway Type</label>
                                            <Controller
                                                name='paymentGatewayType'
                                                defaultValue={InputFields.paymentGatewayType}
                                                rules={{required: true}}
                                                control={control}
                                                render={({field}) => (
                                                    <select value={field.value || ""} className="form-control custom-select" name="paymentGatewayType" onChange={(e) => {updateChangeEvent(e, field)}} disabled={disabledField}>
                                                        <option value="">Choose...</option>
                                                        <option value="cashfree">Cashfree</option>
                                                        <option value="razorpay">Razorpay</option>
                                                        <option value="payu">PayU Money</option>
                                                    </select>
                                                )}
                                            />
                                            <small className="form-text text-danger">
                                                {errors.paymentGatewayType?.type === "required" && "Please select a payment gateway"}
                                            </small>
                                        </Col>
                                        <Col md="6" className="mt-3">
                                            <label className="form-label fs-14rem fw-bold">Payment Mode</label>
                                            <Controller
                                                name='paymentMode' 
                                                defaultValue={InputFields.paymentMode}
                                                rules={{required: true}}
                                                control={control} 
                                                render={({field}) => (
                                                    <select value={field.value || ""} className="form-control custom-select" name="paymentMode" onChange={(e) => {updateChangeEvent(e, field)}} disabled={disabledField}>
                                                        <option value="">Choose...</option>
                                                        <option value="cod">COD (Cash On Delivery)</option>
                                                        <option value="prepaid">Pay Now (Online Payment)</option>
                                                        <option value="both">Both (COD + Pay Now)</option>
                                                    </select>
                                                )}
                                            />	
                                            <small className="form-text text-danger">
                                                {errors.paymentMode?.type === "required" && "Please select a payment mode"}
                                            </small>
                                        </Col>
                                        <Col md="12" className="mt-3">
                                            <label className="form-label fs-14rem fw-bold">Payment Config</label>
                                            <textarea defaultValue={InputFields.paymentConfig} className="form-control" name="paymentConfig" {...register("paymentConfig", { required: true, minLength: 5 })} disabled={disabledField}></textarea>
                                            <div>
                                                <small className="form-text text-muted">
                                                    JSON format: {`{"payment_env":"TEST","cashfree_app_id":"","cashfree_secret_key":"","razorpay_key_id":"","razorpay_key_secret":"","payu_merchant_key":"","payu_merchant_salt":""}`}
                                                </small>
                                            </div>
                                            <div>
                                                <small className="form-text text-danger">
                                                    {errors.paymentConfig?.type === "required" && "Payment Config is mandatory"}
                                                </small>
                                                <small className="form-text text-danger">
                                                    {errors.paymentConfig?.type === "minLength" && "Enter atleast 5 characters"}
                                                </small>
                                            </div>
                                        </Col>
                                        <Col md="12" className="mt-3">
                                            <label className="form-label fs-14rem fw-bold">Instagram Config</label>
                                            <textarea defaultValue={InputFields.instagramConfig} className="form-control" name="instagramConfig" {...register("instagramConfig")} disabled={disabledField}></textarea>
                                            <small className="form-text text-muted">
                                                JSON format: {`{"access_token":"...","user_id":"..."}`}
                                            </small>
                                        </Col>
                                        {(orginfo.roleId === 1) ? <Col md="12" className="text-end">
                                            <Button variant="primary" type="submit" disabled={DisableSubmitButton} className="vt-primary-btn border-0 text-end text-white mt-4 fs-14rem">{SubmitButton}</Button>
                                        </Col> : null }
                                    </>}
                                </Row>
                            </form>
                        </Row>
                    </Container>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" className="fs-14rem" onClick={hideModal}>Close</Button>
                </Modal.Footer>
            </Modal>
            <ToastContainer
                position="top-right"
                autoClose={5000}
                hideProgressBar={false}
                newestOnTop={false}
                closeOnClick
                rtl={false}
                pauseOnFocusLoss
                draggable
                pauseOnHover
            />
        </>
    )
}

export default FormModal;